import { Input } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useEInvoicingAddressForm } from '../../../../../../contexts/eInvoicingAddressFormContext'

export const CustomerCompanyName = () => {
  const { t } = useTranslation()
  const {
    eInvoicingAddressForm: { FormItem },
  } = useEInvoicingAddressForm()

  return (
    <FormItem
      label={t('external_invoices.send_as_e_invoice.modal.field.customer_company_name.label')}
      name="companyName"
      render={({ field: { onChange, ...rest } }) => {
        return <Input {...rest} disabled size="sm" />
      }}
    />
  )
}
